<template>
  <div id="app">
    <a-config-provider :locale="locale" :autoInsertSpaceInButton="false">
      <router-view />
    </a-config-provider>
  </div>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import Cookies from 'js-cookie'
import { getNoToken } from "@/utils/config";

export default {
  name: "App",
  data() {
    return {
      locale: zhCN,
    };
  },
  async mounted() {
    window.addEventListener('unload', () => {
      localStorage.setItem('state', JSON.stringify(this.$store.state))
    });
  },
  created() {
    const noToken = getNoToken()
    let name = location.pathname.replace(/\//g,"")
    if (!Cookies.get('TGC')&&noToken.indexOf(name) == -1) {
      this.$store.dispatch('user/logout')
      return
    }
  }
};
</script>
